"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILSelect = exports.RemoveActiveProp = void 0;
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var il_button_1 = require("../il-button/il-button");
var material_1 = require("@mui/material");
function RemoveActiveProp(_a) {
    var children = _a.children, active = _a.active, props = __rest(_a, ["children", "active"]);
    return react_1.default.cloneElement(children, props);
}
exports.RemoveActiveProp = RemoveActiveProp;
function ILSelect(_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? enums_1.SelectVariantEnum.SINGLE : _c, _d = _a.enforceValueSet, enforceValueSet = _d === void 0 ? true : _d, _e = _a.showSelectAll, showSelectAll = _e === void 0 ? false : _e, _f = _a.component, component = _f === void 0 ? 'div' : _f, sx = _a.sx, _g = _a["data-testid"], dataTestId = _g === void 0 ? 'il-select' : _g, _h = _a["aria-label"], ariaLabel = _h === void 0 ? variant + ' select' : _h, props = __rest(_a, ["variant", "enforceValueSet", "showSelectAll", "component", "sx", 'data-testid', 'aria-label']);
    var Component = component;
    // handle single versus multi select
    var isMulti = variant === enums_1.SelectVariantEnum.MULTI;
    var _j = react_1.default.useState([]), selections = _j[0], setSelections = _j[1];
    var defaultParentProps = {
        sx: sx,
        'aria-label': ariaLabel,
        'data-testid': dataTestId,
    };
    react_1.default.useEffect(function () {
        setSelections(props.defaultSelections || []);
    }, [props.defaultSelections]);
    var isSelected = function (key) { return selections.indexOf(key) >= 0; };
    var changeSelection = function (selection) {
        if (selection instanceof Array) {
            // selection is an array
            setSelections(selection);
            if (props.returnValues && props.returnValues.length) {
                var newValues = selection.map(function (value) {
                    return props.returnValues && props.returnValues[value]
                        ? props.returnValues[value]
                        : 'undefined';
                });
                props.onChange(newValues);
            }
            else {
                props.onChange(selection);
            }
        }
        else if (selection !== null) {
            // selection is a number
            setSelections([selection]);
            if (props.returnValues) {
                props.onChange(props.returnValues[selection]);
            }
            else {
                props.onChange(selection);
            }
        }
        else {
            // selection is null
            setSelections([]);
            props.onChange(null);
        }
    };
    // single select
    var handleSelection = function (key) {
        // already selected
        if (isSelected(key)) {
            // allow reset when not enforcing value set
            if (!enforceValueSet) {
                changeSelection(null);
            }
        }
        else {
            // allow change if not selected
            changeSelection(key);
        }
    };
    // multi select
    var handleSelections = function (key) {
        // already selected
        if (isSelected(key)) {
            // remove from array
            if (selections.length > 1) {
                var newKeys = selections.filter(function (x) { return x !== key; });
                selections.sort(function (a, b) { return a - b; });
                changeSelection(newKeys);
            }
            else if (!enforceValueSet) {
                // allow reset when last one and not enforcing value set
                changeSelection([]);
            }
        }
        else {
            // allow change if not selected
            var newKeys = __spreadArray(__spreadArray([], selections, true), [key], false);
            newKeys.sort(function (a, b) { return a - b; });
            changeSelection(newKeys);
        }
    };
    // select all
    var handleSelectAll = function () {
        var allKeys = Array.from(Array(props.children.length).keys());
        changeSelection(allKeys);
    };
    var getChildProps = function (key, child) {
        var _a;
        return ({
            key: key,
            sx: __assign(__assign({}, (_a = child.props) === null || _a === void 0 ? void 0 : _a.sx), props.childSx),
            active: isSelected(key),
            selected: isSelected(key),
            onClick: function () { return (isMulti ? handleSelections(key) : handleSelection(key)); },
        });
    };
    // Handle children
    if ((_b = props === null || props === void 0 ? void 0 : props.children) === null || _b === void 0 ? void 0 : _b.length) {
        return (react_1.default.createElement(material_1.Box, { sx: { width: 1, display: 'flex', flexDirection: 'column' } },
            isMulti && showSelectAll && (react_1.default.createElement(material_1.Box, { sx: { width: 1, display: 'flex', justifyContent: 'center' } },
                react_1.default.createElement(il_button_1.ILButton, { variant: enums_1.ButtonVariantEnum.TEXT, sx: { textAlign: 'center', mt: 2.5, mb: 3 }, onClick: handleSelectAll }, "Select All"))),
            react_1.default.createElement(material_1.Box, { sx: { width: 1, display: 'flex', justifyContent: 'center' } },
                react_1.default.createElement(Component, __assign({}, defaultParentProps), react_1.default.Children.map(props.children, function (child, key) {
                    return react_1.default.cloneElement(child, getChildProps(key, child));
                })))));
    }
    return (react_1.default.createElement(material_1.Box, { sx: { width: 1, display: 'flex', alignContent: 'center', justifyContent: 'center' } },
        react_1.default.createElement(material_1.Typography, { "aria-label": defaultParentProps['aria-label'], "data-testid": defaultParentProps['data-testid'], variant: enums_1.TypographyVariantEnum.SUBTITLE1 }, props.emptyListText)));
}
exports.ILSelect = ILSelect;
